import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';

function OutputFormatSelector({ input, meta, label }) {
  const intl = useIntl();

  const dataOptions = [
    {
      value: 'excel',
      label: intl.formatMessage({ id: 'ui-reports.outputFormat.excel', defaultMessage: 'Excel' }),
    },
    {
      value: 'pdf',
      label: intl.formatMessage({ id: 'ui-reports.outputFormat.pdf', defaultMessage: 'PDF' }),
    },
    {
      value: 'csv',
      label: intl.formatMessage({ id: 'ui-reports.outputFormat.csv', defaultMessage: 'CSV' }),
    },
    {
      value: 'json',
      label: intl.formatMessage({ id: 'ui-reports.outputFormat.json', defaultMessage: 'JSON' }),
    },
  ];

  return (
    <Select
      input={input}
      meta={meta}
      label={label}
      dataOptions={dataOptions}
      required
    />
  );
}

OutputFormatSelector.propTypes = {
  input: PropTypes.object.isRequired,
  meta:  PropTypes.object.isRequired,
  label: PropTypes.node,
};

export default OutputFormatSelector;
